var $ = require('jQuery');
var checkboxes = require('../../lib/checkboxes.js');
var MarkdownEditor = require('../../lib/markdown-editor.js');

module.exports = function() {
    checkboxes.conditionalEnable('#enable-mobile-registrations', '#mobile-required');

    // Consent
    const markdownEditor = new MarkdownEditor();
    const toolbar = ['bold', 'italic', '|', 'link', '|', 'preview', 'spell-checker'];

    const editableTerms = (container) => {
        container = $(container);

        const textareas = container.find('.editor'),
            button = container.find('.modify-text'),
            customText = container.find('.custom-text'),
            defaultText = container.find('.default-text'),
            customised = container.find('.customised');

        if (customised.val() == 1) {
            defaultText.addClass('hidden');
        } else {
            customText.addClass('hidden');
        }

        let editors = [];

        textareas.each((i, textarea) => {
            let editor = markdownEditor.singleEditor(textarea, toolbar);

            editors.push({
                textarea: textarea,
                editor: editor,
                language: $(textarea).data('language')
            });
        });

        button.on('click', (event) => {
            const currentValue = customised.val();
            const defaults = customText.data('default');

            event.preventDefault();

            defaultText.toggleClass('hidden');
            customText.toggleClass('hidden');

            customised.val(currentValue == 0 ? 1 : 0);

            editors.forEach((editor) => {
                const value = defaults[editor.language];
                editor.editor.codemirror.getDoc().setValue(value);
            });

            if (currentValue == 1) {
                button.text(button.data('modify-label'));
            } else {
                button.text(button.data('reset-label'));
            }
        });
    };

    editableTerms('#agreement-to-terms');
    editableTerms('#consent-to-notifications-and-broadcasts');

    function displaySamlSettings() {
      if ($('#enable-saml').is(':checked')) {
        $('#saml-settings').removeClass('hidden');
      } else {
        $('#saml-settings').addClass('hidden');
      }
    };

    $('#enable-saml').change(displaySamlSettings);

    displaySamlSettings();

    $('#saml-disabled').on('click', function () {
         window.location.href = '/feature-disabled';
    });
};
